import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { checkScreenType } from 'utils';
import { GAClickButton } from 'utils/analytics';
import { selectPageModelTitle } from '../../../../../store/pageModel';
import { selectWindowType, WindowTypes } from '../../../../../store/pageStore';
import { Header, StepNumber, StepsContainer } from '../steps/styles';
import { StyledLink } from './styles';

export const ANALIZ_VODY_FILE_LINK =
	'https://cdn.lemanapro.ru/lmru/image/upload/v1753968684/fudzi/services-platform/analiz-vody.pdf/analiz-vody.pdf';

type StepsProps = {
	title: string;
	categoryPhotoUrl: string;
	listItems: string[];
	className?: string;
};

export const AnalizVodySteps = ({ title, categoryPhotoUrl, listItems, className }: StepsProps) => {
	const screenType = useSelector(selectWindowType);
	const isTablet = checkScreenType(screenType, WindowTypes.tablet);
	const headingVariant = useMemo(() => (isTablet ? 'l' : 'm'), [isTablet]);
	const pageTitle = useSelector(selectPageModelTitle);

	const clickHandler = useCallback(() => {
		GAClickButton({
			elementBlock: 'servicePage',
			elementName: pageTitle,
			elementText: 'Инструкция',
		});
	}, [pageTitle]);

	return (
		<StepsContainer className={className} data-qa="analiz-vody-steps">
			<Header>
				<Typography variant={headingVariant} size="body_accent" data-qa="steps-title">
					{title}
				</Typography>
				<img src={categoryPhotoUrl} alt="Порядок оказания Услуги" data-qa="steps-img" />
			</Header>
			<ol>
				<li key={`step-0`} data-qa="steps-item">
					<StepNumber>
						<Typography variant="caption_accent">1</Typography>
					</StepNumber>
					<Typography variant="s" size="body_long">
						Подготовьте пробу воды по нашей{' '}
						<StyledLink
							href={ANALIZ_VODY_FILE_LINK}
							target="_blank"
							data-qa="steps-link"
							onClick={clickHandler}
						>
							инструкции
						</StyledLink>
					</Typography>
				</li>
				{listItems.map((item, key) => (
					<li key={`step-${item}`} data-qa="steps-item">
						<StepNumber>
							<Typography variant="caption_accent">{key + 2}</Typography>
						</StepNumber>
						<Typography variant="s" size="body_long">
							{item}
						</Typography>
					</li>
				))}
			</ol>
		</StepsContainer>
	);
};
